const searchFieldOptions = []

const searchFieldOperation = {

}

export {searchFieldOptions,searchFieldOperation}



// WEBPACK FOOTER //
// ./src/views/rule/options.js